<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions>
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon
                class="back-link-icon"
                x-large
                @click="$router.push('/students/index')"
            >mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>

      <v-card-title class="text-h5 font-weight-bold">
        مشاهده هنرجو
      </v-card-title>

      <v-card-text>
        <v-row>
          <!-- Student Details Section -->
          <v-col cols="12">
            <v-data-table
                :headers="studentDetailsHeaders"
                :items="[student]"
                hide-default-footer
                item-value="id"
                dense
            >
            </v-data-table>
          </v-col>

          <!-- Profile Image -->
          <v-col cols="12" v-if="student.profile_image" class="text-center">
            <img :src="student.profile_image" width="200" height="200" />
          </v-col>

          <!-- Subscription Info -->
          <v-col cols="12">
            <div class="mt-4">
              <strong>اشتراک فعال تا:</strong> {{ student.subscription_active_until_fa }}
            </div>
            <div class="mt-4">
              <strong>تاریخ ثبت نام:</strong> {{ student.register_date_fa }}
            </div>
            <div class="mt-4">
              <strong>آخرین بازدید سایت:</strong> {{ student.last_visit_fa }}
            </div>
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <!-- Recent Activities -->
          <v-col cols="12">
            <v-card-title>۱۰ فعالیت آخر:</v-card-title>
            <v-data-table
                :headers="activityHeaders"
                :items="student.recent_activities"
                item-value="id"
                dense
            >
              <template v-slot:[`item.user_type`]="{ item }">
                <v-chip x-small color="success" text-color="white" v-if="item.user_type === 'student'">هنرجو</v-chip>
                <span v-else>-</span>
              </template>
              <template #no-data>
                <v-alert type="info" :value="true">
                  هیچ فعالیتی ثبت نشده است
                </v-alert>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <!-- Login History -->
          <v-col cols="12">
            <v-card-title>۱۰ ورود آخر:</v-card-title>
            <v-data-table
                :headers="loginHistoryHeaders"
                :items="student.login_history"
                item-value="id"
                dense
            >
              <template v-slot:[`item.login_method`]="{ item }">
                <v-chip x-small color="primary" text-color="white" v-if="item.login_method === 'otp'">OTP</v-chip>
                <v-chip x-small color="secondary" text-color="white" v-else-if="item.login_method === 'password'">Password</v-chip>
                <span v-else>-</span>
              </template>
              <template v-slot:[`item.is_logged_in`]="{ item }">
                <v-icon color="success" v-if="item.is_logged_in">mdi-check</v-icon>
                <v-icon color="error" v-else>mdi-close</v-icon>
              </template>
              <template #no-data>
                <v-alert type="info" :value="true">
                  هیچ ورودی ثبت نشده است
                </v-alert>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <!-- Classes Table -->
          <v-col cols="12">
            <v-card-title>کلاس‌ها:</v-card-title>
            <v-data-table
                :headers="classesHeaders"
                :items="student.classes"
                item-value="id"
                dense
            >
              <template v-slot:[`item.students`]="{ item }">
                <span v-for="s in item.students" :key="s.id">
                  {{ s.name }}{{ item.students.length > 1 ? '، ' : '' }}
                </span>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <!-- >Educational Status -->
          <v-col cols="12">
            <v-card-title>وضعیت پیشرفت تحصیلی:</v-card-title>
            <v-data-table
                :headers="progressHeaders"
                :items="student.plans.filter(item=> item.item_file_id === null)"
                item-value="id"
                dense
            >
              <template v-slot:[`item.visibility`]="{ item }">
                <span v-if="item.visibility">
                  <v-icon color="success">mdi-check</v-icon>
                </span>
                <span v-else>
                  <v-icon color="error">mdi-close</v-icon>
                </span>
              </template>

              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status === 'open'">
                  باز
                </span>
                <span v-else>
                  بسته
                </span>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <!-- Valid Subscriptions Table -->
          <v-col cols="12">
            <v-card-title>دوره های معتبر:</v-card-title>
            <v-data-table
                :headers="validSubscriptionsHeaders"
                :items="student.valid_subscriptions"
                item-value="id"
                dense
            >
              <template v-slot:[`item.price`]="{ item }">
                {{ Number(item.price).toLocaleString('en-US') }} تومان
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <!-- Transactions Table -->
          <v-col cols="12">
            <v-card-title>تراکنش‌ها:</v-card-title>
            <v-data-table
                :headers="transactionHeaders"
                :items="student.transactions"
                item-value="id"
                dense
            >
              <template v-slot:[`item.amount`]="{ item }">
                {{ Number(item.amount).toLocaleString('en-US') }} تومان
              </template>
              <template #no-data>
                <v-alert type="info" :value="true">
                  هیچ تراکنشی یافت نشد
                </v-alert>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <!-- Notifications Table -->
          <v-col cols="12">
            <v-card-title>اعلان‌ها:</v-card-title>
            <v-data-table
                :headers="notificationsHeaders"
                :items="student.notifications"
                item-value="id"
                dense
            >
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Upload File Dialog -->
    <v-dialog v-model="uploadFileDialog" max-width="50vw">
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "StudentGet",
  data() {
    return {
      uploadFileDialog: false,
      states: [],
      cities: [],
      schools: [],
      progressHeaders:[
        { text: "شناسه", value: "id" },
        { text: "شناسه درس", value: "item_id" },
        { text: "شناسه کلاس", value: "online_class_id" },
        { text: "شناسه دوره", value: "course_id" },
        { text: "وضعیت درس", value: "status" },
        { text: "وضعیت مشاهده", value: "visibility" },
      ],
      loginHistoryHeaders: [
        { text: "شناسه", value: "id" },
        { text: "زمان ورود", value: "updated_at_fa" },
        { text: "روش ورود", value: "login_method" },
        { text: "کد", value: "code" },
        { text: "وارد شده؟", value: "is_logged_in" },
      ],
      activityHeaders: [
        { text: "شناسه", value: "id" },
        { text: "زمان", value: "created_at_fa" },
        { text: "نوع کاربر", value: "user_type" },
        { text: "نام کاربر", value: "user_name" },
        { text: "شماره موبایل", value: "user_mobile" },
        { text: "آخرین فعالیت", value: "title_fa" },
        { text: "صفحه", value: "route_path" },
      ],
      studentDetailsHeaders: [
        { text: "شناسه", value: "id" },
        { text: "نام و نام خانوادگی", value: "name" },
        { text: "ایمیل", value: "email" },
        { text: "شماره همراه", value: "mobile" },
        { text: "کد ملی", value: "national_code" },
        { text: "تاریخ تولد", value: "birth_date_fa" },
        { text: "جنسیت", value: "gender" },
        { text: "وضعیت", value: "status" },
        { text: "استان", value: "state_id" },
        { text: "شهر", value: "city_id" },
        { text: "آموزشگاه", value: "school_id" },
        { text: "موجودی کیف پول", value: "wallet.value" }
      ],
      classesHeaders: [
        { text: "عنوان کلاس", value: "title" },
        { text: "دوره", value: "course.title" },
        { text: "همکلاسی‌ها", value: "students" }
      ],
      validSubscriptionsHeaders: [
        { text: "عنوان", value: "title" },
        { text: "قیمت (تومان)", value: "price" }
      ],
      transactionHeaders: [
        { text: "شناسه تراکنش", value: "id" },
        { text: "تاریخ تراکنش", value: "created_at_fa" },
        { text: "مبلغ (تومان)", value: "amount" },
        { text: "شناسه پیگیری", value: "refid" },
        { text: "نوع", value: "type" },
        { text: "اشتراک", value: "subscription.title" }
      ],
      notificationsHeaders: [
        { text: "زمان ساخت", value: "created_at_fa" },
        { text: "محتوا", value: "content" },
        { text: "مربی", value: "instructor_name" },
        { text: "دیده شده در", value: "seen_at_fa" }
      ],
      student: {
        name: null,
        email: null,
        password: null,
        national_code: null,
        birth_date: null,
        gender: "male",
        mobile: null,
        profile_image: null,
        state_id: null,
        city_id: null,
        school_id: null,
        status: null,
        wallet: { value: null },
        classes: [],
        valid_subscriptions: [],
        transactions: [],
        notifications: [],
        recent_activities: [],
        login_history: []
      }
    };
  },
  mounted() {
    this.getStudent();
    this.getStates();
    this.getSchools();
  },
  methods: {
    getStudent() {
      window.axios.get("admin/student/details/" + this.$route.params.id).then((res) => {
        this.student = res.data.data;
        console.log(this.student, "student");
        this.getCities();
      });
    },
    getStates() {
      window.axios.get("system/state/index").then((res) => {
        this.states = res.data.data;
      });
    },
    getCities() {
      window.axios.get("system/city/index?state_id=" + this.student.state_id).then((res) => {
        this.cities = res.data.data;
      });
    },
    getSchools() {
      window.axios.get("school/admin-index").then((res) => {
        this.schools = res.data.data;
      });
    }
  }
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
